var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEth = function SvgEth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eth_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.893.87a.4.4 0 0 0-.354.227L4.969 9.853l-.025.042h-.001a.4.4 0 0 0-.042.194.4.4 0 0 0 .021.117l.015.037v.001l.02.035a.4.4 0 0 0 .138.14v.001l.007.003h.001l5.55 3.172a.4.4 0 0 0 .493.002l5.544-3.17.043-.026.005-.005.024-.017.002-.002.005-.004a.4.4 0 0 0 .072-.087l.001-.003.019-.032.012-.029.003-.008.011-.037.001-.002v-.002a.4.4 0 0 0 .012-.067v-.003a.4.4 0 0 0-.003-.085v-.001l-.001-.004-.007-.034v-.001a.4.4 0 0 0-.027-.074v-.001L16.86 9.9l-.019-.032-.002-.004-.002-.003-.012-.02-5.567-8.747a.4.4 0 0 0-.365-.224M10.5 2.65V7.41L6.333 9.197zm.8 0 4.166 6.547L11.3 7.41zm-.8 5.632v4.304l-4.304-2.459zm.8 0 4.303 1.845-4.303 2.459zm5.203 3.393q-.108 0-.202.053L10.9 14.815l-5.402-3.087a.401.401 0 0 0-.52.585l5.573 7.564a.4.4 0 0 0 .696 0l5.575-7.564a.4.4 0 0 0-.32-.638m-9.758 1.687 3.755 2.146v2.95zm8.31 0L11.3 18.458v-2.95z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "eth_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.5.475h20v20H.5z"
  })))));
};
export default SvgEth;